<template>
    <v-row>
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>   
        <v-col v-else id="base" md="12" class="pb-0 mb-0" >
                        
            <v-row justify="start" style="font-size: 23px" class="RestoRegular pl-4">
                Mis datos
            </v-row>
            <v-row justify="center" align="start" style="width: 95%; margin: 0 auto">
                <v-col>
                    <v-row style="background-color: #E6E6E6; border-radius: 5px" >
                        <v-col class="RestoRegular ml-2 mb-1">
                            <v-row  style="line-height: 15px; font-size: 13px" :style="{ 'color': $store.state.colors.primary }"> 
                                Nombre
                            </v-row>
                            <v-row style="color: #4D4D4D; line-height: 17px; font-size: 15px" class="RestoBold">
                                {{userData.nombre}} {{userData.apellidos}}
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                        <v-col class="RestoRegular ml-2 mb-1">
                            <v-row style="line-height: 15px; font-size: 13px" :style="{ 'color': $store.state.colors.primary }">
                                Mail
                            </v-row>
                            <v-row style="color: #4D4D4D; line-height: 17px; font-size: 15px" class="RestoBold">
                                {{userData.correo}}
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row justify="center" class="mt-6">
                        <v-btn @click="goToPass()" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                            Cambiar Contraseña
                        </v-btn>
                    </v-row>

                    <!-- <v-row style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                        <v-col class="RestoRegular ml-2 mb-1">
                            <v-row style="line-height: 15px; font-size: 13px" :style="{ 'color': $store.state.colors.primary }">
                                Dirección de facturación TO DO
                            </v-row>
                            <v-row style="color: #4D4D4D; line-height: 17px; font-size: 15px" class="RestoBold">
                                Nombre de la Calle, 000 C,20000, colonia, ciudad
                            </v-row>
                        </v-col>
                    </v-row> -->

                    <!-- <v-row v-for="(address, index) in addresses" :key="index" style="background-color: #E6E6E6">
                        <v-col align-self="center" cols="auto">
                            <v-img src="@/assets/resources/user/casa.svg" max-width="25px"></v-img>
                        </v-col>
                        <v-col align-self="center" style="font-size: 12px" class="RestoRegular">
                            <v-row class="RestoBold" style="font-size: 13px">
                                {{address.alias}}
                            </v-row>
                            <v-row>
                                {{address.calle}} {{address.num_exterior}} {{address.num_interior}} {{address.colonia}} CP {{address.cp}}
                            </v-row>
                        </v-col>
                        <v-col align-self="center" cols="auto">
                            <a style="color: #FF4030; font-size: 14px" class="RestoBold">
                                Editar
                            </a>
                        </v-col>
                        <v-col align-self="center" cols="auto">
                            <v-radio-group v-model="active" class="my.0 py-0">
                                <v-radio color="red"  :value="address.alias" class="my-0 py-0">
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row> -->
                </v-col>
            </v-row>

        </v-col>
    </v-row>
</template>


<script>
export default {
    data() {
        return {
            userData: {
                nombre: "",
                apellidos: "",
                correo: ""
                },
            validateLoad:true,
        }
    },
    methods: {
        goToPass() {
            this.$router.push({name: 'newPass'});
        }
    },
    async created() 
    {
        // console.log(localStorage.getItem("id_cliente"));
        await this.$store.dispatch("GET", {url: '/datos_c/' + localStorage.getItem("id_cliente"), headers: {Authorization: localStorage.getItem("token")}})
            .then(response => {
                this.userData = response.data[0];
                this.validateLoad=false;
                // console.log(this.userData);
            })
            .catch(error => {
                console.log("Error: " + error);
            });
    }
}
</script>

<style scoped>

</style>